import { COLLAPSE_ICON, type SideRailSide } from './sideRail';

const COLLAPSE_BUTTON_CLASSES = 'p-1 rounded hover:bg-gray-100 text-gray-500 transition-colors';

interface SideRailCollapseButtonProps {
    side: SideRailSide;
    panelName: string;
    onCollapse: () => void;
}

function SideRailCollapseButton({ side, panelName, onCollapse }: SideRailCollapseButtonProps) {
    const CollapseIcon = COLLAPSE_ICON[side];
    const title = `Collapse ${panelName}`;

    return (
        <button
            type="button"
            onClick={onCollapse}
            className={COLLAPSE_BUTTON_CLASSES}
            title={title}
            aria-label={title}
        >
            <CollapseIcon className="w-3.5 h-3.5" />
        </button>
    );
}

export { SideRailCollapseButton };
